const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

function getUnitLetter(index: number) {
  let result = "";
  index++; // shift to 1-based indexing
  while (index > 0) {
    index--; // adjust for 0-based array
    result = letters[index % 26] + result;
    index = Math.floor(index / 26);
  }
  return result;
}

export default getUnitLetter;
